/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
  TextField,
  Paper,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../services/AuthService";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialState = {
  password: "",
  newPassword: "",
  newPasswordConfirm: "",
};
//
// ########################################################################### 
//
const CambioPassword = () => {
  const navigate = useNavigate();
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPasswordConfirm, setShowNewPasswordConfirm] = useState(false);

  const { hasPermission } = useContext(AuthContext);
  const _cambiarPassword = hasPermission("usuario-cambiar-password");

  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSave();
    }
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    setData((prevData) => ({
      ...prevData,
      password: prevData.password.trim(),
      newPassword: prevData.newPassword.trim(),
      newPasswordConfirm: prevData.newPasswordConfirm.trim(),
    }));

    if (!data.password) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar tu contraseña actual",
      });
      setShowMessage(true);
      return;
    }

    if (!data.newPassword) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar tu nueva contraseña",
      });
      setShowMessage(true);
      return;
    }

    if (!data.newPasswordConfirm) {
      setMessage({
        severity: "error",
        messageText: "Debes confirmar tu nueva contraseña",
      });
      setShowMessage(true);
      return;
    }

    const _tieneEspacios = /\s/.test(data.newPassword);

    if (_tieneEspacios) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña no puede contener espacios en blanco",
      });
      setShowMessage(true);
      return;
    }

    if (data.newPassword !== data.newPasswordConfirm) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña y su confirmación no coinciden",
      });
      setShowMessage(true);
      return;
    }

    if (data.password === data.newPassword) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña no puede ser igual a la actual",
      });
      setShowMessage(true);
      return;
    }

    if (data.newPassword.length < 6 || data.newPassword.length > 20) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña debe tener entre 6 y 20 caracteres",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {

    const _params = {
      id: localStorage.getItem("id_usuario"),
      password_actual: data.password,
      password_nuevo: data.newPassword,
      password_confirmacion: data.newPasswordConfirm
    };

    setIsDoingSomething(true);
    const response = await changePassword(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      navigate("/login");
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    };
  };
  //
  // ################################################################################
  //
  const handleCancel = () => {
    setData(initialState);
  };
  //
  // ################################################################################
  //
  return (
    <Box sx={{ mt: 4 }}>
      <Grid
        container
        justifyContent="center"
        sx={{ minHeight: "100vh" }}
      >
        <Grid>
          <Paper sx={{ p: 4, width: 400 }}>
            <Grid
              container
              direction="column"
              spacing={2}
            >
              <Grid sx={{ mb: 2 }}>
                <Typography
                  variant="h5"
                  align="center"
                >
                  Cambio de contraseña
                </Typography>
              </Grid>

              <Grid>
                <TextField
                  fullWidth
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="password"
                  label="Contraseña actual"
                  variant="outlined"
                  size="small"
                  name="password"
                  value={data.password}
                  type={showPassword ? "text" : "password"}
                  autoFocus
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          size="large"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>

              <Grid>
                <TextField
                  fullWidth
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="newPassword"
                  label="Nueva contraseña"
                  variant="outlined"
                  size="small"
                  name="newPassword"
                  value={data.newPassword}
                  type={showNewPassword ? "text" : "password"}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle new password visibility"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          edge="end"
                          size="large"
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>

              <Grid>
                <TextField
                  fullWidth
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="newPasswordConfirm"
                  label="Confirmación de nueva contraseña"
                  variant="outlined"
                  size="small"
                  name="newPasswordConfirm"
                  value={data.newPasswordConfirm}
                  type={showNewPasswordConfirm ? "text" : "password"}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle repeat password visibility"
                          onClick={() => setShowNewPasswordConfirm(!showNewPasswordConfirm)}
                          edge="end"
                          size="large"
                        >
                          {showNewPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="flex-end"
                >

                  {_cambiarPassword && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={handleSave}
                      color="primary"
                      startIcon={<SaveIcon />}
                    >
                      Cambiar Contraseña
                    </Button>
                  )}

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancel}
                  >
                    Cancelar
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      < WaitingDialog open={isDoingSomething} />
    </Box>
  );
};
export default CambioPassword;
